import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  isMobile: false,
  imgPrefix: process.env.VUE_APP_BASE_URL,
  routeList: [],
  navIndex: localStorage.getItem("navIndex")
    ? localStorage.getItem("navIndex")
    : 0
};

const mutations = {
  SetScreenWidth(state, data) {
    state.isMobile = data;
  },
  SetRouteList(state, data) {
    state.routeList = [...data];
  },
  SetNavIndex(state, data) {
    state.navIndex = data;
  }
};

const getters = {
  GetScreenDevice: state => {
    return state.isMobile;
  },
  GetRouteList: state => {
    return state.routeList;
  },
  GetNavIndex: state => {
    return state.navIndex;
  }
};

export default new Vuex.Store({
  state,
  mutations,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js